import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/instagram/callback — the shared sign-in callback (ChannelCallback) for Instagram. */
const InstagramCallback: React.FC = () => <ChannelCallback platform="instagram" />;

export default InstagramCallback;
